import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import ls from 'local-storage'
import store from './data-store/store'
import jwtDecode from 'jwt-decode'
import { loginSuccess } from './data-store/actions/auth'
import { setConfig } from './data-store/actions/global'
import AppRouter from 'src/routers/AppRouter'
import { ThemeProvider } from '@mui/material/styles'
import CustomTheme from './CustomTheme'
import CssBaseline from '@mui/material/CssBaseline'
import { StyledEngineProvider } from '@mui/styled-engine'

if (ls('token')) {
  const token = ls('token')
  const userData = jwtDecode(token)
  userData.initials = userData.given_name?.charAt(0) + userData.family_name?.charAt(0)
  const expiry = userData.exp
  const now = new Date()
  if (now.getTime() < expiry * 1000) {
    store.dispatch(loginSuccess(userData))
  }
}

if (window.__env) {
  store.dispatch(setConfig(window.__env))
}

const container = document.getElementById('app')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <ThemeProvider theme={CustomTheme}>
      <CssBaseline />
      <StyledEngineProvider injectFirst>
        <AppRouter />
      </StyledEngineProvider>
    </ThemeProvider>
  </Provider>
)